import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import InputField from "../../../../components/InputField";
import api from "../../../../api/api";
import * as Yup from "yup";
import { Modal } from "react-bootstrap";
import Button from "../../../../components/Button";
import BackButton from "../../../../components/BackButton";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import "./ViewSIAdmin.css";
import Select, { components } from "react-select";
 
const CreateSIAdmin = () => {
  const { id } = useParams();
  const [enquiry, setEnquiry] = useState();
  const [showConfirm, setShowConfirm] = useState(false);
  const [showBLConfirm, setShowBLConfirm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFreightAmount, setShowFreightAmount] = useState(false);
  const [creatingBL, setCreatingBL] = useState(false);
  const navigate = useNavigate();
 
  // Stamp selection states
  const [selectedStamps, setSelectedStamps] = useState({
    containerStamps: [],
    descriptionStamps: [],
    measurementStamps: [],
  });
 
  // Delivery Agent selection
  const [selectedDeliveryAgent, setSelectedDeliveryAgent] = useState("");
 
  // Place of Issue selection
  const [selectedPlaceOfIssue, setSelectedPlaceOfIssue] = useState("");
  const [placeOfIssueError, setPlaceOfIssueError] = useState("");
 
  // Date of Issue selection
  const [dateOfIssue, setDateOfIssue] = useState(null);
  const [dateOfIssueError, setDateOfIssueError] = useState("");
  
  // Date of Issue 2 selection (for BL2 when switch_bl = 'Yes')
  const [dateOfIssueBl2, setDateOfIssueBl2] = useState(null);
  const [dateOfIssueBl2Error, setDateOfIssueBl2Error] = useState("");
 
  // Place of Issue options
  const placeOfIssueOptions = [
    { value: "Mumbai", label: "Mumbai (22)" },
    { value: "New Delhi", label: "New Delhi (11)" },
    { value: "Chennai", label: "Chennai (44)" },
    { value: "Kolkatta", label: "Kolkatta (33)" },
    { value: "Chandigarh", label: "Chandigarh (72)" },
  ];
 
  // BL Source selection
  const [selectedBLSource, setSelectedBLSource] = useState("");
  const [blSourceError, setBlSourceError] = useState("");
 
  // BL Source options
  const blSourceOptions = [
    { value: "NaavVaayu", label: "NaavVaayu (In-house)" },
    { value: "Other Shipping Line", label: "Other Shipping Line" }
  ];
 
  // Delivery Agent options
  const deliveryAgentOptions = [
    {
      value:
        "PARSIAN GOLDEN ROUTE INTL TPT CO.,\nADDRESS NO.5, 2ND FLOOR, SOUTH\nBOZORGMEHR, 22 ST, SAJJAD BLVD, MASHAD, IRAN\nNATIONAL CODE: 10380647995\nREGISTRATION CODE : 48440",
      label: "PARSIAN GOLDEN ROUTE INTL TPT CO.",
    },
    {
      value:
        "NOBLE LINE LOGISTICS LLC\nOFFICE#21, 7TH FLOOR (IBC) DUBAI NATIONAL INSURANCE & REINSURANCE BUILDING, PORT SAEED, DEIRA, DUBAI,UAE.",
      label: "NOBLE LINE LOGISTICS LLC",
    },
    {
      value:
        "BAHAR TARABAR KIAN INTL TPT CO.\nUNIT 503,5TH FLOOR, ZAMEN AHOO COMPLEX, MAJD\nINTERSECTION,QARANI BLVD, MASHHAD, IRAN. POSTAL\nCODE:9195812137 NATIONAL\nID:10380647961/REGISTRATION CODE-48433\nCELL:00989019085261\nTEL:+985137289031-3 FAX:+985137289034\nE MAIL:BTK.FORWARDER@GMAIL.COM",
      label: "BAHAR TARABAR KIAN INTL TPT CO.",
    },
    {
      value:
        "NEW SAKSHI ASADULLAH LTD\nAYOBI DARMAL MARKET SHAH ZAMAN WATT KANDAHAR AFGHANISTAN\n 0704441230",
      label: "NEW SAKSHI ASADULLAH LTD",
    },
    {
      value:
        "KIAN MARINE STAR Shipping & International Freight\nTEL:076-33548354-5\nADDRESS : No.9 3rd Floor NIA Budling Daneshmand intersection Pasdaran Blvd Bandar Abbas -IRAN\nEMAIL:\nmanager@kianmarinestar.com.   National ID: 14012448401\nRegistration code 23259",
      label: "KIAN MARINE STAR Shipping & International Freight",
    },
  ];
 
  // Stamp options
  const containerStampOptions = [
    "ALL DESTINATION / DELIVERY CHARGES ON ACCOUNT OF CONSIGNEE AS PER CARRIER'S TARIFF",
    "DESTINATION CHARGES COLLECT",
    "SHIPPER'S LOAD STOW, COUNT SEAL AND WEIGHT",
    "LINER DEMURRAGE / DETENTION WILL BE PAYABLE TO LINER TARIFF",
    "DESTINATION CHARGES ON ACCOUNT OF CONSIGNEE",
    "DDC COLLECT",
    "DDC PREPAID",
  ];
 
  const descriptionStampOptions = [
    "FREIGHT PREPAID",
    "FREIGHT COLLECT",
    "ORIGIN CHARGES PREPAID",
    "ORIGIN CHARGES COLLECT",
    "DESTINATION CHARGES PREPAID",
    "DESTINATION CHARGES COLLECT",
    "DDC COLLECT",
    "DDC PREPAID",
  ];
 
  const measurementStampOptions = [
    "LCL/LCL",
    "LCL/FCL",
    "FCL/FCL",
    "PART OF 40'",
    "PART OF 20'",
  ];
 
  const handleStampChange = (category, stamps) => {
    setSelectedStamps((prev) => {
      // Handle array (from react-select multi-select)
      if (Array.isArray(stamps)) {
        return { ...prev, [category]: stamps };
      }
      // Handle single value (for checkbox backward compatibility)
      const current = prev[category];
      const updated = current.includes(stamps)
        ? current.filter((s) => s !== stamps)
        : [...current, stamps];
      return { ...prev, [category]: updated };
    });
  };
 
  useEffect(() => {
    const fetchEnquiry = async () => {
      try {
        const response = await api.get(`/enquiry/viewEnquiry/${id}`);
        setEnquiry(response.data);
 
        // Load stamps from database (if exists)
        if (response.data.stamps) {
          try {
            const parsedStamps = JSON.parse(response.data.stamps);
            setSelectedStamps(parsedStamps);
          } catch (e) {
            console.error("Error parsing stamps:", e);
          }
        }
 
        // Load delivery agent from database (if exists)
        if (response.data.delivery_agent) {
          setSelectedDeliveryAgent(response.data.delivery_agent);
        }
 
        // Load Place of Issue from database (if exists)
        if (response.data.place_of_issue) {
          setSelectedPlaceOfIssue(response.data.place_of_issue);
        }
 
        // Load BL Source from database (if exists)
        if (response.data.bl_source) {
          setSelectedBLSource(response.data.bl_source);
        }
  
        // Load Date of Issue from database (if exists)
        if (response.data.date_of_issue) {
          // Convert date to yyyy-mm-dd format for the date input
          const date = new Date(response.data.date_of_issue);
          const formattedDate = date.toISOString().split("T")[0];
          setDateOfIssue(formattedDate);
        }
        
        // Load Date of Issue BL2 from database (if exists)
        if (response.data.date_of_issue_bl2) {
          const dateBl2 = new Date(response.data.date_of_issue_bl2);
          const formattedDateBl2 = dateBl2.toISOString().split("T")[0];
          setDateOfIssueBl2(formattedDateBl2);
        }
      } catch (error) {
        console.error(error);
      }
    };
 
    fetchEnquiry();
  }, [id]);
 
  const handleSuccessClose = () => {
    setShowSuccess(false);
    navigate(`/view-bl-draft/${id}`);
  };
 
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: enquiry
      ? {
          shipper_name: enquiry.first_shipper_name || "",
          notify_party: enquiry.notify_party_1 || "",
          consignee_name: enquiry.first_consignee_name || "",
          port_of_loading: enquiry.pol || "",
          port_of_discharge: enquiry.pod || "",
          marks_and_numbers: enquiry.marks_and_packages || "",
          number_and_kind_of_packages: enquiry.packaging_type || "",
          gross_weight: enquiry.gross_weight || "",
          place_of_receipt: enquiry.Placeof_Receipt || "",
          measurements: enquiry.measurement || "",
          place_of_delivery: enquiry.Placeof_Delivery || "",
          total_number_of_containers: enquiry.number_of_containers || "",
          number_of_originals: enquiry.number_of_originals || "",
          freight_terms: enquiry.freight_terms || "",
          vessel_name: enquiry.vessel_name || "",
          voyage_no: enquiry.voyage_number || "",
          document_type: enquiry.document_type || "",
          containers: (enquiry.containerDetails || []).map((c) => ({
            ...c,
            container_number: c.container_number || "",
            seal_number: c.seal_number || "",
          })),
          mode_of_shipment: enquiry.mode_of_shipment || "",
          general_description_of_goods: enquiry.general_description || "",
        }
      : {
          shipper_name: "",
          notify_party: "",
          consignee_name: "",
          port_of_loading: "",
          port_of_discharge: "",
          marks_and_numbers: "",
          number_and_kind_of_packages: "",
          gross_weight: "",
          place_of_receipt: "",
          measurements: "",
          place_of_delivery: "",
          total_number_of_containers: "",
          number_of_originals: "",
          freight_terms: "",
          vessel_name: "",
          voyage_no: "",
          document_type: "",
          containers: [],
          mode_of_shipment: "",
          general_description_of_goods: "",
        },
    validationSchema: Yup.object({
      shipper_name: Yup.string().required("Required"),
      notify_party: Yup.string().required("Required"),
      consignee_name: Yup.string().required("Required"),
      port_of_loading: Yup.string().required("Required"),
      port_of_discharge: Yup.string().required("Required"),
      marks_and_numbers: Yup.string().required("Required"),
      number_and_kind_of_packages: Yup.string().required("Required"),
      gross_weight: Yup.number()
        .typeError("Must be a number")
        .required("Required"),
      place_of_receipt: Yup.string().required("Required"),
      measurements: Yup.string().required("Required"),
      place_of_delivery: Yup.string().required("Required"),
      total_number_of_containers: Yup.number()
        .typeError("Must be a number")
        .required("Required"),
      number_of_originals: Yup.number()
        .typeError("Must be a number")
        .required("Required")
        .min(1, "Minimum value is 1")
        .max(3, "Maximum value is 3"),
      freight_terms: Yup.string().required("Required"),
      vessel_name: Yup.string().required("Required"),
      voyage_no: Yup.string().required("Required"),
      document_type: Yup.string().required("Required"),
      containers: Yup.array().of(
        Yup.object().shape({
          container_number: Yup.string().required(
            "Container number is required",
          ),
          seal_number: Yup.string().required("Seal number is required"),
        }),
      ),
      mode_of_shipment: Yup.string(),
      general_description_of_goods: Yup.string().required("Required"),
    }),
    onSubmit: () => {
      setShowConfirm(true);
    },
  });
 
  const handleConfirm = async () => {
    setShowConfirm(false);
    try {
      const payload = {
        ...formik.values,
        enq_id: id,
        gross_weight: parseFloat(formik.values.gross_weight),
        total_number_of_containers: parseFloat(
          formik.values.total_number_of_containers,
        ),
        number_of_originals: parseFloat(formik.values.number_of_originals),
        notificationType: "shared",
      };
      await api.post(`/si-admin/createSI`, payload);
      setShowSuccess(true);
    } catch (error) {
      console.error(error);
    }
  };
 
  const handleCreateBLDraft = async () => {
    // Validate BL Source selection first
    if (!selectedBLSource) {
      setBlSourceError("BL Source is required");
      return;
    }

    // Validate Place of Issue selection first
    if (!selectedPlaceOfIssue) {
      setPlaceOfIssueError("Place of Issue is required");
      return;
    }
 
    // Validate Date of Issue selection
    if (!dateOfIssue) {
      setDateOfIssueError("Date of Issue is required");
      return;
    }
 
    setPlaceOfIssueError("");
    setDateOfIssueError("");
    setBlSourceError("");
    const errors = await formik.validateForm();
    if (Object.keys(errors).length === 0) {
      setShowBLConfirm(true);
    } else {
      const touched = Object.keys(errors).reduce((acc, key) => {
        if (key === "containers") {
          acc.containers = formik.values.containers.map(() => ({
            container_number: true,
            seal_number: true,
          }));
        } else {
          acc[key] = true;
        }
        return acc;
      }, {});
      formik.setTouched(touched);
    }
  };
 
  const handleConfirmBL = async () => {
    setCreatingBL(true);
    try {
      const payload = {
        ...formik.values,
        enq_id: id,
        gross_weight: parseFloat(formik.values.gross_weight),
        total_number_of_containers: parseFloat(
          formik.values.total_number_of_containers,
        ),
        number_of_originals: parseFloat(formik.values.number_of_originals),
        show_freightAmount: showFreightAmount ? 1 : 0,
        notificationType: "shared",
        stamps: selectedStamps,
        delivery_agent: selectedDeliveryAgent,
        place_of_issue: selectedPlaceOfIssue,
        date_of_issue: dateOfIssue,
        date_of_issue_bl2: dateOfIssueBl2,
        bl_source: selectedBLSource,
      };
      await api.post(`/si-admin/createSI`, payload);
      // Save form data to localStorage before navigating
      localStorage.setItem(`siAdminForm_${id}`, JSON.stringify(formik.values));
      // Save selected stamps to localStorage for ViewBLDraft
      localStorage.setItem(`blStamps_${id}`, JSON.stringify(selectedStamps));
      // Save selected delivery agent to localStorage for ViewBLDraft
      localStorage.setItem(`deliveryAgent_${id}`, selectedDeliveryAgent);
      // Save selected Place of Issue to localStorage for ViewBLDraft
      localStorage.setItem(`placeOfIssue_${id}`, selectedPlaceOfIssue);
      navigate(`/view-bl-draft/${id}`);
    } catch (error) {
      console.error(error);
    } finally {
      setCreatingBL(false);
    }
  };
 
  const handleEmailShippingInstructions = async () => {
    const errors = await formik.validateForm();
    if (Object.keys(errors).length === 0) {
      // Placeholder for email functionality - implement API call to send email
      alert("Email Shipping Instructions functionality to be implemented");
    } else {
      formik.setTouched(
        Object.keys(errors).reduce((acc, key) => ({ ...acc, [key]: true }), {}),
      );
    }
  };
 
  if (!enquiry) return <div>Loading...</div>;
 
  return (
    <>
      <BackButton />
      <form onSubmit={formik.handleSubmit}>
        <div className="row ">
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Shipper Name"
              name="shipper_name"
              placeholder="Enter Shipper Name"
              value={formik.values.shipper_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.shipper_name && formik.errors.shipper_name}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Notify Party"
              name="notify_party"
              placeholder="Enter Notify Party"
              value={formik.values.notify_party}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.notify_party && formik.errors.notify_party}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Consignee Name"
              name="consignee_name"
              placeholder="Enter Consignee Name"
              value={formik.values.consignee_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.consignee_name && formik.errors.consignee_name
              }
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Port of Loading"
              name="port_of_loading"
              placeholder="Enter Port of Loading"
              value={formik.values.port_of_loading}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.port_of_loading && formik.errors.port_of_loading
              }
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Port of Discharge"
              name="port_of_discharge"
              placeholder="Enter Port of Discharge"
              value={formik.values.port_of_discharge}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.port_of_discharge &&
                formik.errors.port_of_discharge
              }
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Marks & Numbers"
              name="marks_and_numbers"
              placeholder="Enter Marks & Numbers"
              value={formik.values.marks_and_numbers}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.marks_and_numbers &&
                formik.errors.marks_and_numbers
              }
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Number & Kind of Packages"
              name="number_and_kind_of_packages"
              placeholder="Enter Number & Kind of Packages"
              value={formik.values.number_and_kind_of_packages}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.number_and_kind_of_packages &&
                formik.errors.number_and_kind_of_packages
              }
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Gross Weight"
              name="gross_weight"
              type="number"
              placeholder="Enter Gross Weight"
              value={formik.values.gross_weight}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.gross_weight && formik.errors.gross_weight}
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Place of Receipt"
              name="place_of_receipt"
              placeholder="Enter Place of Receipt"
              value={formik.values.place_of_receipt}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.place_of_receipt &&
                formik.errors.place_of_receipt
              }
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Measurements"
              name="measurements"
              placeholder="Enter Measurements"
              value={formik.values.measurements}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.measurements && formik.errors.measurements}
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Place of Delivery"
              name="place_of_delivery"
              placeholder="Enter Place of Delivery"
              value={formik.values.place_of_delivery}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.place_of_delivery &&
                formik.errors.place_of_delivery
              }
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Total Number of Containers"
              name="total_number_of_containers"
              type="number"
              placeholder="Enter Total Number of Containers"
              value={formik.values.total_number_of_containers}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.total_number_of_containers &&
                formik.errors.total_number_of_containers
              }
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Number of Originals"
              name="number_of_originals"
              type="number"
              placeholder="Enter Number of Originals (1-3)"
              value={formik.values.number_of_originals}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.number_of_originals &&
                formik.errors.number_of_originals
              }
              min="1"
              max="3"
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Freight Terms"
              name="freight_terms"
              placeholder="Enter Freight Terms"
              value={formik.values.freight_terms}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.freight_terms && formik.errors.freight_terms
              }
              disabled
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Vessel Name"
              name="vessel_name"
              placeholder="Enter Vessel Name"
              value={formik.values.vessel_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.vessel_name && formik.errors.vessel_name}
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Voyage No"
              name="voyage_no"
              placeholder="Enter Voyage No"
              value={formik.values.voyage_no}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.voyage_no && formik.errors.voyage_no}
            />
          </div>
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Document Type"
              name="document_type"
              placeholder="Enter Document Type"
              value={formik.values.document_type}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.document_type && formik.errors.document_type
              }
              disabled
            />
          </div>
          {formik.values.containers && formik.values.containers.length > 0 && (
            <div className="col-12 mb-3">
              <h5 className="fs-6 fw-bold CreateSI">
                Please Assign container number and Seal number to the following
                containers.
              </h5>
              <table
                className="table table-bordered"
                style={{ marginTop: "20px" }}
              >
                <thead>
                  <tr>
                    {enquiry.shipment_segment !== "LE" &&
                      enquiry.shipment_segment !== "LI" && (
                        <th>Container Type</th>
                      )}
                    <th>Weight</th>
                    <th>Length</th>
                    <th>Height</th>
                    <th>Breadth</th>
                    {enquiry.nature_of_cargo === "Temperature Control" && (
                      <th>Temperature</th>
                    )}
                    <th>Container Number</th>
                    <th>Seal Number</th>
                  </tr>
                </thead>
                <tbody>
                  {formik.values.containers.map((container, index) => (
                    <tr key={index}>
                      {enquiry.shipment_segment !== "LE" &&
                        enquiry.shipment_segment !== "LI" && (
                          <td>{container.container_type}</td>
                        )}
                      <td>{container.container_weight}</td>
                      <td>{container.container_length}</td>
                      <td>{container.container_height}</td>
                      <td>{container.container_breadth}</td>
                      {enquiry.nature_of_cargo === "Temperature Control" && (
                        <td>{container.container_temperature}</td>
                      )}
                      <td>
                        <InputField
                          name={`containers.${index}.container_number`}
                          placeholder="Enter Container Number"
                          value={
                            formik.values.containers[index].container_number
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.containers &&
                            formik.touched.containers[index] &&
                            formik.touched.containers[index].container_number &&
                            formik.errors.containers &&
                            formik.errors.containers[index] &&
                            formik.errors.containers[index].container_number
                          }
                        />
                      </td>
                      <td>
                        <InputField
                          name={`containers.${index}.seal_number`}
                          placeholder="Enter Seal Number"
                          value={formik.values.containers[index].seal_number}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.containers &&
                            formik.touched.containers[index] &&
                            formik.touched.containers[index].seal_number &&
                            formik.errors.containers &&
                            formik.errors.containers[index] &&
                            formik.errors.containers[index].seal_number
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Mode of Shipment"
              name="mode_of_shipment"
              placeholder="Enter Mode of Shipment"
              value={formik.values.mode_of_shipment}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.mode_of_shipment &&
                formik.errors.mode_of_shipment
              }
            />
          </div>
          <div className=" col-sm-6 col-md-4 mb-3">
            <InputField
              label="General Description of Goods"
              name="general_description_of_goods"
              placeholder="Enter General Description of Goods"
              value={formik.values.general_description_of_goods}
              type="textarea"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.general_description_of_goods &&
                formik.errors.general_description_of_goods
              }
              inpcls="customtextarea"
            />
          </div>
          <div className=" col-sm-6 col-md-4 mb-3">
            <label className="form-label">Delivery Agent</label>
            <Select
              name="deliveryAgent"
              options={deliveryAgentOptions}
              value={deliveryAgentOptions.find(
                (opt) => opt.value === selectedDeliveryAgent,
              )}
              onChange={(option) =>
                setSelectedDeliveryAgent(option ? option.value : "")
              }
              placeholder="Select Delivery Agent..."
              className="basic-select"
              classNamePrefix="select"
            />
          </div>
        </div>
 
        <div className="row mb-3">
          <div className="col-sm-6 col-md-4 mb-3">
            <label className="form-label">
              Place of Issue <span className="text-danger">*</span>
            </label>
            <Select
              name="placeOfIssue"
              options={placeOfIssueOptions}
              value={placeOfIssueOptions.find(
                (opt) => opt.value === selectedPlaceOfIssue,
              )}
              onChange={(option) => {
                setSelectedPlaceOfIssue(option ? option.value : "");
                if (option) setPlaceOfIssueError("");
              }}
              placeholder="Select Place of Issue..."
              className={`basic-select ${placeOfIssueError ? "is-invalid" : ""}`}
              classNamePrefix="select"
              styles={{
                control: (provided) => ({
                  ...provided,
                  borderColor: placeOfIssueError
                    ? "#dc3545"
                    : provided.borderColor,
                }),
              }}
            />
            {placeOfIssueError && (
              <div
                className="text-danger"
                style={{ fontSize: "0.875rem", marginTop: "0.25rem" }}
              >
                {placeOfIssueError}
              </div>
            )}
          </div>
          <div className=" col-sm-6 col-md-4 mb-3">
            <label className="form-label">
              Date of Issue <span className="text-danger">*</span>
            </label>
 
            <div style={{ position: "relative", width: "100%" }}>
              <DatePicker
                selected={dateOfIssue ? new Date(dateOfIssue) : null}
                onChange={(date) => {
                  setDateOfIssue(date);
                  if (date) setDateOfIssueError("");
                }}
                dateFormat="dd/MM/yyyy"
                className={`form-control w-100 ${
                  dateOfIssueError ? "is-invalid" : ""
                }`}
                // style={{ width: "400px" }}
                placeholderText="Select Date of Issue"
                calendarClassName="custom-calendar"
              />
 
              <CalendarMonthIcon
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#6c757d",
                }}
              />
            </div>
 
            {dateOfIssueError && (
              <div className="invalid-feedback d-block">{dateOfIssueError}</div>
            )}
          </div>
          
          {/* Date of Issue BL2 - Only visible when Switch BL = Yes */}
          {(enquiry?.switch_bl === 'Yes' || enquiry?.document_type === 'Switch BL') && (
            <div className="col-sm-6 col-md-4 mb-3">
              <label className="form-label">
                Date of Issue (BL2) <span className="text-danger"></span>
              </label>
 
              <div style={{ position: "relative", width: "100%" }}>
                <DatePicker
                  selected={dateOfIssueBl2 ? new Date(dateOfIssueBl2) : null}
                  onChange={(date) => {
                    setDateOfIssueBl2(date);
                    if (date) setDateOfIssueBl2Error("");
                  }}
                  dateFormat="dd/MM/yyyy"
                  className={`form-control w-100 ${
                    dateOfIssueBl2Error ? "is-invalid" : ""
                  }`}
                  placeholderText="Select Date of Issue for BL2"
                  calendarClassName="custom-calendar"
                />

                <CalendarMonthIcon
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    color: "#6c757d",
                  }}
                />
              </div>

              {dateOfIssueBl2Error && (
                <div className="invalid-feedback d-block">{dateOfIssueBl2Error}</div>
              )}
            </div>
          )}
          <div className="col-sm-6 col-md-4 mb-3">
            <label className="form-label">
              BL Source <span className="text-danger">*</span>
            </label>
            <Select
              name="blSource"
              options={blSourceOptions}
              value={blSourceOptions.find(opt => opt.value === selectedBLSource)}
              onChange={(option) => {
                setSelectedBLSource(option ? option.value : "");
                setBlSourceError("");
              }}
              placeholder="Select BL Source..."
              className="basic-select"
              classNamePrefix="select"
            />
            {blSourceError && (
              <div className="invalid-feedback d-block">{blSourceError}</div>
            )}
          </div>
  
          {/* Stamp Selection on Main Page - Single Dropdown with Multi-select and Search */}
          {/* <div className="col-sm-6 col-md-4 mb-3">
              <label className="form-label">Select Stamps for BL</label>
 
              <Select
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                name="allStamps"
                options={[
                  ...containerStampOptions.map((stamp) => ({
                    value: `container:${stamp}`,
                    label: stamp,
                  })),
                  ...descriptionStampOptions.map((stamp) => ({
                    value: `description:${stamp}`,
                    label: stamp,
                  })),
                  ...measurementStampOptions.map((stamp) => ({
                    value: `measurement:${stamp}`,
                    label: stamp,
                  })),
                ]}
                value={[
                  ...selectedStamps.containerStamps.map((stamp) => ({
                    value: `container:${stamp}`,
                    label: stamp,
                  })),
                  ...selectedStamps.descriptionStamps.map((stamp) => ({
                    value: `description:${stamp}`,
                    label: stamp,
                  })),
                  ...selectedStamps.measurementStamps.map((stamp) => ({
                    value: `measurement:${stamp}`,
                    label: stamp,
                  })),
                ]}
                onChange={(options) => {
                  const container = [];
                  const description = [];
                  const measurement = [];
 
                  options?.forEach((opt) => {
                    const [type, value] = opt.value.split(":");
                    if (type === "container") container.push(value);
                    else if (type === "description") description.push(value);
                    else if (type === "measurement") measurement.push(value);
                  });
 
                  setSelectedStamps({
                    containerStamps: container,
                    descriptionStamps: description,
                    measurementStamps: measurement,
                  });
                }}
                placeholder="Search & Select Stamps"
                classNamePrefix="select"
                styles={{
                  control: (base) => ({
                    ...base,
                    maxHeight: "35px",
                    minHeight: "35px",
                    borderRadius: "12px",
                    border: "1px solid #ced4da",
                    backgroundColor: "aliceblue",
                    boxShadow: "none",
                    overflow: "hidden",
                    borderRadius: "0.5rem",
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    height: "35px",
                    overflowY: "auto",
                    flexWrap: "nowrap",
                  }),
                  multiValue: (base) => ({
                    ...base,
                    fontSize: "10px",
                  }),
                  menuList: (base) => ({
                    ...base,
                    maxHeight: "100px",
                    overflowY: "auto",
                    fontSize: "12px",
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isSelected
                      ? "#cfe2ff"
                      : state.isFocused
                        ? "#e9ecef"
                        : "#fff",
                    color: "#000",
                    fontWeight: state.isSelected ? "600" : "400",
                  }),
                }}
              />
            </div> */}
          <div className="col-sm-6 col-md-4 mb-3">
            <label className="form-label">Select Stamps for BL</label>
            <Select
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              name="allStamps"
              // Tooltip
              components={{
                MultiValueLabel: (props) => (
                  <components.MultiValueLabel {...props}>
                    <div
                      title={props.data.label}
                      style={{
                        maxWidth: "80px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {props.data.label}
                    </div>
                  </components.MultiValueLabel>
                ),
              }}
              options={[
                ...containerStampOptions.map((stamp) => ({
                  value: `container:${stamp}`,
                  label: stamp,
                })),
                ...descriptionStampOptions.map((stamp) => ({
                  value: `description:${stamp}`,
                  label: stamp,
                })),
                ...measurementStampOptions.map((stamp) => ({
                  value: `measurement:${stamp}`,
                  label: stamp,
                })),
              ]}
              value={[
                ...selectedStamps.containerStamps.map((stamp) => ({
                  value: `container:${stamp}`,
                  label: stamp,
                })),
                ...selectedStamps.descriptionStamps.map((stamp) => ({
                  value: `description:${stamp}`,
                  label: stamp,
                })),
                ...selectedStamps.measurementStamps.map((stamp) => ({
                  value: `measurement:${stamp}`,
                  label: stamp,
                })),
              ]}
              onChange={(options) => {
                const container = [];
                const description = [];
                const measurement = [];
 
                options?.forEach((opt) => {
                  const [type, value] = opt.value.split(":");
                  if (type === "container") container.push(value);
                  else if (type === "description") description.push(value);
                  else if (type === "measurement") measurement.push(value);
                });
 
                setSelectedStamps({
                  containerStamps: container,
                  descriptionStamps: description,
                  measurementStamps: measurement,
                });
              }}
              placeholder="Search & Select Stamps"
              classNamePrefix="select"
              styles={{
                control: (base) => ({
                  ...base,
                  maxHeight: "35px",
                  minHeight: "35px",
                  border: "1px solid #ced4da",
                  backgroundColor: "aliceblue",
                  boxShadow: "none",
                  overflow: "hidden",
                  borderRadius: "0.5rem",
                }),
                valueContainer: (base) => ({
                  ...base,
                  height: "35px",
                  overflowY: "auto",
                  flexWrap: "nowrap",
                }),
                multiValue: (base) => ({
                  ...base,
                  fontSize: "10px",
                  maxWidth: "90px",
                }),
                menuList: (base) => ({
                  ...base,
                  maxHeight: "100px",
                  overflowY: "auto",
                  fontSize: "12px",
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected
                    ? "#cfe2ff"
                    : state.isFocused
                      ? "#e9ecef"
                      : "#fff",
                  color: "#000",
                  fontWeight: state.isSelected ? "600" : "400",
                }),
              }}
            />
          </div>
        </div>
 
        <div className="row">
          <div className="col-sm-3">
            <Button
              text="Create BL Draft"
              variant="primary"
              size="md"
              onClick={handleCreateBLDraft}
            />
          </div>
          <div className="col-sm-6"></div>
          <div className="col-sm-3 d-flex justify-content-end">
            <Button
              text="Email Shipping Instructions"
              variant="primary"
              size="md"
              onClick={handleEmailShippingInstructions}
            />
          </div>
        </div>
      </form>
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Submission</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to submit this?</Modal.Body>
        <Modal.Footer>
          <Button
            text="Cancel"
            variant="secondary"
            onClick={() => setShowConfirm(false)}
          />
          <Button text="Confirm" variant="primary" onClick={handleConfirm} />
        </Modal.Footer>
      </Modal>
      <Modal
        show={showBLConfirm}
        onHide={() => setShowBLConfirm(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Create BL Draft</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <p>Are you sure you want to create the BL draft?</p>
          <div className="mt-3 mb-3">
            <input
              type="checkbox"
              id="showFreightAmount"
              checked={showFreightAmount}
              onChange={(e) => setShowFreightAmount(e.target.checked)}
            />
            <label htmlFor="showFreightAmount" className="ms-2">
              Do you want to show the Freight Amount on the BL?
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            text="Cancel"
            variant="secondary"
            onClick={() => setShowBLConfirm(false)}
            disabled={creatingBL}
          />
          <Button
            text={creatingBL ? "Creating..." : "Confirm"}
            variant="primary"
            onClick={handleConfirmBL}
            disabled={creatingBL}
          />
          {creatingBL && (
            <div className="spinner-border text-primary ms-2" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          )}
        </Modal.Footer>
      </Modal>
      <Modal show={showSuccess} onHide={handleSuccessClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>Shipping instructions created successfully!</Modal.Body>
        <Modal.Footer>
          <Button text="OK" variant="success" onClick={handleSuccessClose} />
        </Modal.Footer>
      </Modal>
    </>
  );
};
 
export default CreateSIAdmin;
 